import { render, staticRenderFns } from "./say.vue?vue&type=template&id=0d02e906&"
import script from "./say.vue?vue&type=script&lang=js&"
export * from "./say.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports